//import Libraries
import React from 'react';

//import Components


//import Style classes
import './HistoryCard.css'

const greetingCard = (props) => {
    return (
        <div className="HistoryCard">
            <h3>{props.data.year}</h3>
            <p>{props.data.content[props.lang]+"  "}</p>
            <p>{props.data.month ? props.data.year+". "+props.data.month+"." : null}</p>
        </div>
    )
}

export default greetingCard;


// WEBPACK FOOTER //
// ./src/pages/About/History/HistoryCard/HistoryCard.js